import Header from "../../../../../components/header";
import { FestivalSkeletonGrayBox } from "../../style/skeleton";
import { FestivalInterviewBannerWrapper } from "./components/banner/style";
import {
  FestivalInterviewContentWrapper,
  FestivalInterviewContentInfo,
  FestivalInterviewContentText,
} from "./components/content/style";
import { FestivalInterviewWrapper } from "./style";

const RabbitFestivalInterviewSkeleton = () => {
  return (
    <FestivalInterviewWrapper>
      <Header
        title="RABBIT FESTIVAL"
        show={true}
        img={`/image-web/news/share_white.svg`}
      />
      <FestivalInterviewBannerWrapper>
        <img src="/image-web/rabbit/interview_back.png" alt="banner" />
      </FestivalInterviewBannerWrapper>
      <FestivalInterviewContentWrapper>
        <div className="title">우승자 인터뷰</div>
        <FestivalInterviewContentInfo>
          <FestivalSkeletonGrayBox width="80px" height="17px" />
          <FestivalSkeletonGrayBox width="60px" height="17px" />
        </FestivalInterviewContentInfo>
        <FestivalInterviewContentText>
          <FestivalSkeletonGrayBox width="100%" height="500px" />
        </FestivalInterviewContentText>
      </FestivalInterviewContentWrapper>
    </FestivalInterviewWrapper>
  );
};

export default RabbitFestivalInterviewSkeleton;
